import React from 'react';

import CategoricalSummary from './CategoricalSummary';

import NumericalSummary from 'components/NumericalSummary';
import withToolsetPlaceholder from 'components/ToolsetPlaceholder';
import SummaryTableParameters from '../../../src/components/Dataset/SummaryTableParameters';

const UnivariateSummaries = () =>
  <div className="page-main__indent">
    <div className="flex flex-grow">
      <div className="settings-width mb-15 mr-15">
        <SummaryTableParameters />

      </div>
      <div className="graph-width mb-15">
        <NumericalSummary className="mb-15" />
        <CategoricalSummary className="mb-15" />
      </div>
    </div>
  </div>;

export default withToolsetPlaceholder(UnivariateSummaries);
